import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "detail-section mt-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted"
}


export default {
  __name: 'StudentBookingGroups',
  props: {
  groups: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "text-muted section-title" }, " Buchungsgruppen ", -1 /* CACHED */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.id,
        class: "mb-1"
      }, _toDisplayString(group.name), 1 /* TEXT */))
    }), 128 /* KEYED_FRAGMENT */)),
    (!__props.groups.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Keine Buchungsgruppen "))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}